<template>
  <div class="register">
    <div class="register__close">
      <UtilityIconButton
        v-tippy="{ theme: 'statzon', placement: 'left', arrow: true, animation: 'scale' }"
        content="Close"
        size="lg"
        variant="round"
        backgroundColor="#12130f"
        highlightColor="rgba(255,255,255,0.7)"
        highlightBackgroundColor="#070806"
        @click.native="resetSearch()"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M23 20.168l-8.185-8.187 8.185-8.174-2.832-2.807-8.182 8.179-8.176-8.179-2.81 2.81 8.186 8.196-8.186 8.184 2.81 2.81 8.203-8.192 8.18 8.192z"/></svg>
      </UtilityIconButton>
    </div>

    <div class="register__left">
      <div class="register__left--top">
        <div class="register__logo" />

        <div class="list">
          <h2>Empower Your Strategy with Statzon's Data-Driven Insights:</h2>
          <div class="spacer" />

          <div class="list__item">
            <div class="list__icon list__icon--green">
              <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M23.334 11.96c-.713-.726-.872-1.829-.393-2.727.342-.64.366-1.401.064-2.062-.301-.66-.893-1.142-1.601-1.302-.991-.225-1.722-1.067-1.803-2.081-.059-.723-.451-1.378-1.062-1.77-.609-.393-1.367-.478-2.05-.229-.956.347-2.026.032-2.642-.776-.44-.576-1.124-.915-1.85-.915-.725 0-1.409.339-1.849.915-.613.809-1.683 1.124-2.639.777-.682-.248-1.44-.163-2.05.229-.61.392-1.003 1.047-1.061 1.77-.082 1.014-.812 1.857-1.803 2.081-.708.16-1.3.642-1.601 1.302s-.277 1.422.065 2.061c.479.897.32 2.001-.392 2.727-.509.517-.747 1.242-.644 1.96s.536 1.347 1.17 1.7c.888.495 1.352 1.51 1.144 2.505-.147.71.044 1.448.519 1.996.476.549 1.18.844 1.902.798 1.016-.063 1.953.54 2.317 1.489.259.678.82 1.195 1.517 1.399.695.204 1.447.072 2.031-.357.819-.603 1.936-.603 2.754 0 .584.43 1.336.562 2.031.357.697-.204 1.258-.722 1.518-1.399.363-.949 1.301-1.553 2.316-1.489.724.046 1.427-.249 1.902-.798.475-.548.667-1.286.519-1.996-.207-.995.256-2.01 1.145-2.505.633-.354 1.065-.982 1.169-1.7s-.135-1.443-.643-1.96zm-12.584 5.43l-4.5-4.364 1.857-1.857 2.643 2.506 5.643-5.784 1.857 1.857-7.5 7.642z"/></svg>
            </div>
            <div class="list__text">
              <b>Free Account:</b> Gain immediate insight into market trends and analytics with complimentary access to essential global statistics. Activate your no-cost account and begin navigating the data landscape with ease.
            </div>
          </div>

          <div class="list__item">
            <div class="list__icon list__icon--green">
              <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M23.334 11.96c-.713-.726-.872-1.829-.393-2.727.342-.64.366-1.401.064-2.062-.301-.66-.893-1.142-1.601-1.302-.991-.225-1.722-1.067-1.803-2.081-.059-.723-.451-1.378-1.062-1.77-.609-.393-1.367-.478-2.05-.229-.956.347-2.026.032-2.642-.776-.44-.576-1.124-.915-1.85-.915-.725 0-1.409.339-1.849.915-.613.809-1.683 1.124-2.639.777-.682-.248-1.44-.163-2.05.229-.61.392-1.003 1.047-1.061 1.77-.082 1.014-.812 1.857-1.803 2.081-.708.16-1.3.642-1.601 1.302s-.277 1.422.065 2.061c.479.897.32 2.001-.392 2.727-.509.517-.747 1.242-.644 1.96s.536 1.347 1.17 1.7c.888.495 1.352 1.51 1.144 2.505-.147.71.044 1.448.519 1.996.476.549 1.18.844 1.902.798 1.016-.063 1.953.54 2.317 1.489.259.678.82 1.195 1.517 1.399.695.204 1.447.072 2.031-.357.819-.603 1.936-.603 2.754 0 .584.43 1.336.562 2.031.357.697-.204 1.258-.722 1.518-1.399.363-.949 1.301-1.553 2.316-1.489.724.046 1.427-.249 1.902-.798.475-.548.667-1.286.519-1.996-.207-.995.256-2.01 1.145-2.505.633-.354 1.065-.982 1.169-1.7s-.135-1.443-.643-1.96zm-12.584 5.43l-4.5-4.364 1.857-1.857 2.643 2.506 5.643-5.784 1.857 1.857-7.5 7.642z"/></svg>
            </div>
            <div class="list__text">
              <b>Premium Subscription:</b> Broaden your analytical horizon with Statzon's expansive suite of market insights. Access over 14 million data points, market reports, and news from a diverse and robust collection of more than +80,000 sources.
            </div>
          </div>
        </div>
      </div>

      <div class="register__left--bottom">
        <div class="testimonials">
          <UtilityQuote
            :name="testimonials[testimonial].name"
            :title="testimonials[testimonial].title"
            :company="testimonials[testimonial].company"
            :portrait="testimonials[testimonial].portrait"
          >
            <i>{{ testimonials[testimonial].quote }}</i>
          </UtilityQuote>
        </div>
      </div>
    </div>

    <div class="register__right">
      <div class="register__form">
        <AuthRegister
          v-if="$route.meta.step === 'a'"
          @registered="userRegistered()"
        />

        <AuthVerify
          v-if="$route.meta.step === 'c'"
          @verified="userVerified()"
        />

        <AuthThanks
          v-if="$route.meta.step === 'd'"
          @loggingIn="goToLogin()"
        />
      </div>
    </div>
  </div>
</template>

<script>
import AuthRegister from '@/components/auth/Register.vue'
import AuthVerify from '@/components/auth/Verify.vue'
import AuthThanks from '@/components/auth/Thanks.vue'
import UtilityQuote from '@/components/utility/Quote.vue'
import UtilityIconButton from '@/components/utility/IconButton.vue'

export default {
  components: {
    AuthRegister,
    AuthVerify,
    AuthThanks,
    UtilityQuote,
    UtilityIconButton
  },
  metaInfo () {
    return {
      title: this.pageTitle
    }
  },
  data () {
    return {
      formActivated: false,
      successAnimation: false,
      testimonialInterval: false,
      testimonial: 0,
      testimonials: [{
        'name': 'Edouard Guillaume',
        'title': 'Marketing Manager',
        'company': 'STÄUBLI',
        'portrait': '/img/portraits/edouard_guillaume.jpeg',
        'quote': '“We had 15 people using Statzon in the beginning. For us, it is a single point of truth for market information. That’s why we took more users.”'
      }, {
        'name': 'Oliver Giertz',
        'title': 'Product Manager',
        'company': 'Mitsubishi Electric',
        'portrait': '/img/portraits/oliver_giertz.jpeg',
        'quote': '“Statzon is a living system. It is always updating and new data and market reports are added. It is much easier to get the data with Statzon. Often when I have bought a report, it is a screenshot, and the data is not updated. That is a big difference and a big advantage in Statzon.”'
      }, {
        'name': 'Helmut Schmid',
        'title': 'CEO and Chairman',
        'company': 'Agilox Services and Deutscher Robotik Verband',
        'portrait': '/img/portraits/helmut_schmid.jpeg',
        'quote': '“We use Statzon to find what is the next market or segment to invest in and to grow our company. This is mainly based on data. For me, Statzon is much easier because I don’t need to Google and scroll all reports. I go to Statzon and get not only one source but many sources and data to compare. This is what Statzon is for.”'
      }, {
        'name': 'Alexander Schwarz',
        'title': 'Head of Business Development',
        'company': 'Medicaroid',
        'portrait': '/img/portraits/alexander_schwarz.jpeg',
        'quote': '“With Statzon, we found all the relevant information for our market entrance we were looking for, and we found it a lot faster than with any other services. The finely detailed, precise data was immediately accessible to us.”'
      }]
    }
  },
  computed: {
    isAuthenticated () {
      return this.$store.getters['user/isAuthenticated']
    },
    verificationHash () {
      return this.$store.getters['app/getVerificationHash']
    },
    pageTitle () {
      return this.$route.name
    }
  },
  async created () {
    if (this.isAuthenticated) {
      this.$router.push('/')
    } else if (['b', 'c'].includes(this.$route.meta.step)) {
      if (this.verificationHash === false) {
        if (this.$route.params.hash && this.$route.params.hash.length === 32) {
          await this.$store.dispatch('app/setRegistrationInfo', this.$route.params.hash)
        }
      }

      if (this.verificationHash === false) {
        this.$router.push('/register')
      }
    } else if (['d'].includes(this.$route.meta.step)) {
      if (this.verificationHash === false) {
        this.$router.push('/login')
      }
    }

    this.testimonialInterval = setInterval(function () {
      this.testimonial++
      if (this.testimonial >= 4) {
        this.testimonial = 0
      }
    }.bind(this), 10000)
  },
  methods: {
    userRegistered () {
      setTimeout(function () {
        this.$router.push('/register/verify')
      }.bind(this), 1000)
    },
    userVerified () {
      setTimeout(function () {
        this.$router.push('/register/thanks')
      }.bind(this), 1000)
    },
    resetSearch () {
      this.$store.dispatch('search/resetState')
      this.$router.push('/')
    },
    goToLogin () {
      this.$router.push('/login')
    }
  },
  unmounted () {
    clearInterval(this.testimonialInterval)
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/app.scss';

.register {
  display: flex;
  flex-direction: column-reverse;
  width: 100%;
  height: auto;
  min-height: 100vh;

  @media screen and (min-width: $breakpointMd) {
    flex-direction: row;
  }

  h1, h2 {
    @include font('header--sm', $black, 0.6);
    width: 90%;
    margin: 0 auto;
    text-align: center;
  }

  &__logo {
    @media screen and (min-width: $breakpointMd) {
      width: 166px;
      height: 26px;
      background-image: url('/img/statzon_logo_dark_animated.svg');
      background-size: contain;
      background-repeat: no-repeat;
      margin: 0 auto 2rem auto;
      background-position: 0px 0px;
    }
  }

  &__left {
    position: relative;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    flex: 0.3;
    background-color: $bg-5;

    @media screen and (min-width: $breakpointMd) {
      flex: 0.42;
    }

    @media screen and (min-width: $breakpointLg) {
      flex: 0.35;
    }

    &--top {
      margin-top: 3rem;

      .list {
        padding: 5%;
        width: 90%;

        @media screen and (min-width: $breakpointMd) {
          padding: 0 5% 5% 5%;
        }
      }
    }
  }

  &__right {
    display: flex;
    justify-content: top;
    flex-direction: column;
    flex: 0.7;
    background-color: $bg-4;
    background-image: url('/img/pattern_navy.png');
    background-position: 0 0;
    background-repeat: repeat;
    padding-top: 5vh;
    padding-bottom: 5vh;

    @media screen and (min-width: $breakpointMd) {
      flex: 0.58;
      padding-bottom: 2.5vh;
    }

    @media screen and (min-width: $breakpointLg) {
      flex: 0.65
    }
  }

  &__form {
    width: 90%;
    max-width: 460px;
    margin: 0 auto;
  }

  &__close {
    position: fixed;
    top: 8px;
    right: 16px;
    z-index: 99;
  }
}

.spacer {
  width: 36px;
  height: 5px;
  background-color: rgba($bg-4, 0.6);
  margin: 0.5rem auto 0.75rem auto;
  border-radius: 999px;
}

.list {
  @include font('content--md', $black, 0.6);
  width: 100%;
  margin: 0 auto 4rem auto;
  padding: 1.5rem 0;
  text-align: center;
  background-color: $bg-5;

  @media screen and (min-width: $breakpointMd) {
    background-color: rgba($white, 0);
  }

  @media screen and (min-width: $breakpointXl) {
    @include font('content--lg', $black, 0.6);
    padding: 1.5rem 0;
  }

  &__item {
    display: flex;
    align-items: center;
    justify-items: center;
    justify-content: center;
    margin: 1rem 0rem;
    text-align: center;
  }

  &__icon {
    width: 18px;
    min-width: 18px;
    height: 18px;
    min-height: 18px;
    margin: 2px 8px 0 0;
    align-self: flex-start;

    @media screen and (min-width: $breakpointLg) {
      width: 20px;
      min-width: 20px;
      height: 20px;
      min-height: 20px;
      margin: 2px 8px 0 0;
    }

    &--green {
      fill: darken($success, 3);
    }
  }
}

.testimonials {
  display: flex;
  align-items: flex-end;
  width: 100%;
  margin: 0 auto;
  min-height: 240px;
  height: auto;
  padding: 1.5rem 0;
  background-color: $bg-5;

  @media screen and (min-width: $breakpointMd) {
    min-height: auto;
    height: 35vh;
    padding: 0;
  }
}

</style>
